import ListingsActions from './listings_actions';
import alt, { AltStoreModel } from '../alt';
import { APIListingsResponse } from './listing';

export interface State {
  response: APIListingsResponse;
  preloaded: boolean; // Was the store populated on initial page load?
  loaded: boolean;
  loading: boolean;
  fetchError: boolean;
}

class ListingsStore extends AltStoreModel<State> implements State {
  loaded = false;

  loading = false;

  preloaded = false;

  fetchError = false;

  response = {
    current_page: 0,
    total_pages: 0,
    per_page: 0,
    total: 0,
    listings: [],
    suggestion: '',
    humanized_params: '',
    ships_to: '',
    facets: {
      filters: [],
      sorts: {},
    },
    _links: {},
  };

  constructor() {
    super();

    this.bindActions(ListingsActions);
  }

  get initialState(): State {
    return {
      loaded: false,
      loading: false,
      preloaded: false,
      fetchError: false,
      response: {
        current_page: 0,
        total_pages: 0,
        per_page: 0,
        total: 0,
        listings: [],
        suggestion: '',
        humanized_params: '',
        ships_to: '',
        facets: {
          filters: [],
          sorts: {},
        },
        _links: {},
      },
    };
  }

  onListingsLoading() {
    this.setState({
      loaded: false,
      loading: true,
      preloaded: false,
    });
  }

  onListingsLoaded(searchResponse: APIListingsResponse) {
    this.setState({
      loaded: true,
      loading: false,
      preloaded: false,
      fetchError: false,
      response: searchResponse,
    });
  }

  onErrorLoadingListings() {
    this.setState({
      ...this.initialState,
      loaded: true,
      loading: false,
      preloaded: false,
      fetchError: true,
    });
  }

  onPreloadClear() {
    this.setState({
      preloaded: false,
    });
  }

  resetState() {
    this.setState(this.initialState);
  }
}

export default alt.createStore(ListingsStore, 'ListingsStore');
